import type { DesignCard } from './DesignGrid';

export default function BestCreationsGrid({ cards }: { cards: DesignCard[] }) {
  return (
    <div className="best-creations-grid">
      {cards.map(card => (
        <button
          key={card.key}
          className={`best-creation-card${card.isActive ? ' is-active' : ''}`}
          type="button"
          onClick={card.onSelect}
        >
          <div className="best-creation-preview">
            {card.previewUrl ? (
              <img className="best-creation-img" src={card.previewUrl} alt={card.name} />
            ) : (
              <div className="best-creation-loading">
                <div className="loading-spinner" />
              </div>
            )}
          </div>
          <span className="best-creation-name">{card.name}</span>
        </button>
      ))}
    </div>
  );
}
